import { render, staticRenderFns } from "./pagamento.vue?vue&type=template&id=16c77b60"
import script from "./pagamento.vue?vue&type=script&lang=js"
export * from "./pagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports